import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <section className="min-h-screen bg-[#0f1a29] flex flex-col items-center justify-center">
    <div className="bg-white rounded-2xl shadow-2xl p-10 text-center">
      <h1 className="text-6xl font-bold text-brand-blue mb-4">404</h1>
      <p className="text-xl text-gray-700 mb-6">Sorry, the page you are looking for does not exist.</p>
      <Link to="/" className="px-6 py-3 bg-brand-blue text-white rounded-lg shadow hover:bg-blue-700 transition font-semibold">Back to Home</Link>
    </div>
  </section>
);

export default NotFound; 